// extracted by mini-css-extract-plugin
export default {"button":"MailToAll_button__0vvBa"};